import type { VueRoute } from "ui-kit/RouterVue";
import { h } from "vue";

const routes: VueRoute[] = [
  {
    path: "/election-areas/:slug?",
    action: async ({ pathname }) => {
      const id = pathname.groups.slug;
      const c = await import("./views/electionAreaEdit.vue");
      return h(c.default, { id });
    },
  },
  {
    path: "/elections/:slug?",
    action: async ({ pathname }) => {
      const id = pathname.groups.slug;
      const c = id
        ? await import("./views/electionEdit.vue")
        : await import("./views/elections.vue");
      return h(c.default, { id });
    },
  },
];

export default routes;
